import { useEffect, useState } from 'react';
import { api } from '../api';
import { isBilltoro } from '../produkt';
import type { AppConfig } from '../types';

let cached: Promise<AppConfig> | null = null;
const BILLTORO = isBilltoro();
const FALLBACK: AppConfig = {
  kanzleiName: BILLTORO ? 'Billtoro' : 'Elbcons',
  kanzleiPhone: null,
  mailEnabled: false,
  produkt: BILLTORO ? 'billtoro' : 'kanzlei',
  produktName: BILLTORO ? 'Billtoro' : 'Elbcons',
  supportEmail: null,
  webseiteUrl: null,
  // Billtoro: Link „Kostenlos registrieren“ zeigen, bis der Server etwas anderes sagt
  signup: BILLTORO,
  billing: false,
  testTage: 0,
};

// Öffentliche Einstellungen, einmal pro Seitenaufruf geladen. Was der Server (noch) nicht schickt, kommt aus FALLBACK.
export function configLaden(): Promise<AppConfig> {
  cached ??= api
    .get<Partial<AppConfig>>('/api/config')
    .then((c) => ({ ...FALLBACK, ...c }))
    .catch(() => {
      cached = null;
      return FALLBACK;
    });
  return cached;
}

// Öffentliche Einstellungen (Kanzleiname, Telefon, E-Mail-Versand an/aus), einmal pro Seitenaufruf geladen.
export function useConfig(): AppConfig {
  const [cfg, setCfg] = useState<AppConfig>(FALLBACK);
  useEffect(() => {
    let alive = true;
    void configLaden().then((c) => alive && setCfg(c));
    return () => {
      alive = false;
    };
  }, []);
  return cfg;
}
